import { render, staticRenderFns } from "./IssueLogIDBrowse.vue?vue&type=template&id=32ed980d"
import script from "./IssueLogIDBrowse.vue?vue&type=script&lang=js"
export * from "./IssueLogIDBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports